export default {
  onboarding: {
    actions: {
      mainBlue: 'Commencer'
    }
  },
  details: {
    aboutProperty: 'Informations complémentaires',
    title: 'Merci de nous confirmer les informations suivantes:',
    errorMsgInputTxt: 'Champs obligatoire',
    errorMsgGeneral: 'Vérifiez le formulaire avant de continuer',
    errorImages: 'Veuillez ajouter des photos avant de continuer',
    address: {
      literal: 'Adresse',
      placeholder: 'Entrer un lieu'
    },
    zipCode: {
      literal: 'Code postal'
    },
    propertyType: {
      literal: 'Type de propriété',
      options: {
        appartment: 'Appartement',
        maison: 'Maison',
        local_commercial: 'Local commercial'
      }
    },
    residentType: {
      literal: 'Type de résident',
      options: {
        propietarie: 'Propiétaire',
        locataire: 'Locataire',
        propietarie_non_occupant: 'Propiétaire Non Occupant'
      }
    },
    moreThanTwoYears: {
      literal: 'Age de l’immeuble',
      options: {
        less: 'Moins de 2 ans',
        more: 'Plus de 2 ans'
      }
    },
    observations: {
      literal: 'Observations'
    },
    map: {
      empty: {
        title: 'Sans adresse',
        text: 'Veuillez saisir une adresse valide'
      }
    },
    textArea: {
      placeHolder:
        'Longueur du texte limitée à 255 caractères maximum'
    }
  },
  closing: {
    actions: {
      mobilierButton: 'Continuer avec les dommages aux meubles'
    }
  },
  compensationType: {
    title: 'Gérer un sinistre n’a jamais été aussi facile',
    subtitle: 'Concernant vos dommages immobiliers ',
    text: 'Nous vous proposons trois solutions possibles:',
    recommended: 'Notre recommandation!',
    amount: 'Béneficiez d’une indemnisation de',
    e2eCompensations: {
      gagDetail: {
        title: 'Vous êtes bricoleur?',
        text: 'Nous couvrons le coût du matériel, des frais de petit outillage et vous indemnisons pour le temps passé.',
        link: 'Consulter le détail de l’indemnisation proposée'
      },
      billma: {
        title: 'Indemnisation sur devis',
        text: 'Envoyez-nous le devis du prestataire de votre choix, celui-ci devra être révisé par notre cellule technique.',
        link: 'Sélectionner'
      },
      renDetail: {
        title: 'Service réparation',
        text: 'Profitez de notre service réparation, il s’occupe de tout. Pas d’avance, de fonds ni de gestion à effectuer. Il suffit de nous signaler vos disponibilité pour une prise de rendez-vous avec un de nos artisan.',
        link: 'Prendre rendez-vous'
      }
    }
  },
  compensationMobilier: {
    title: 'Concernant vos dommages mobiliers',
    subtitle: 'Montant de l’indemnité',
    total: 'Total:',
    totalAmount: 'Total indemnisation',
    actions: {
      primary: 'Oui, j’accepte l’indemnisation proposée',
      secondary: 'Je souhaite parler avec un conseiller'
    }
  }
}
